import { styled } from '@mui/material/styles'

export const BestFitResultCardLayout = {
  Body: styled('div', {
    name: 'Body',
    slot: 'Root',
    skipSx: true,
    skipVariantsResolver: true,
  })(({ theme }) => ({
    display: 'flex',
    fontSize: '14px',
    lineHeight: '21px',
    padding: theme.spacing(1.6),
    backgroundColor: '#F9FAFB',
    justifyContent: 'space-between',
  })),

  Right: styled('div', {
    name: 'Right',
    slot: 'Root',
    skipSx: true,
    skipVariantsResolver: true,
  })(() => ({
    textAlign: 'right',
  })),

  Left: styled('div', {
    name: 'Left',
    slot: 'Root',
    skipSx: true,
    skipVariantsResolver: true,
  })``,

  Times: styled('div', {
    name: 'Times',
    slot: 'Root',
    skipSx: true,
    skipVariantsResolver: true,
  })(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    backgroundColor: '#F9FAFB',
    '> div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(1),
      '> p': {
        marginRight: theme.spacing(2.5),
      },
    },
  })),
}
